import { z } from 'zod'

/**
 * Deploy stamp served by API `GET /version` and web `GET /version.json`.
 * `env` stays a free string: unknown `NODE_ENV` values (for example staging)
 * are passed through rather than rejected.
 */
export const appVersionDtoSchema = z.object({
  sha: z.string().min(1),
  env: z.string().min(1),
})

export type AppVersionDto = z.infer<typeof appVersionDtoSchema>
